export default "__VITE_ASSET__AgXjEUQ4__"